<div class="recipient">
    <div class="recipient__left-side">
        <i class="bi bi-send-check-fill"></i>
    </div>
    <div class="recipient__main">
        <div>
            <span class="fw-bold">Pour: </span>
            @if(recipient().recipient) {
            @if(recipient().recipient.kind === 'service') {
            Service -
            }@else if(recipient().recipient.kind === 'group') {
            Groupe -
            }
            <span>{{recipientName()}}</span>
            }@else {
            <span>Inconnu</span>
            }
        </div>
        <div>
            <span class="italic small">De: </span>
            @if(recipient().demander && demanderName().length) {
            <span>{{ demanderName()}}</span>
            }
            @else {
            <span>Inconnu</span>
            }
        </div>
        <div>
            <span class="italic small">Envoyé le: </span>
            <span class="italic small">{{(recipient().createdAt | date: 'EEE dd/MM/yyyy hh:mm') | titlecase}}</span>
        </div>
    </div>
    <div class="recipient__message">
        @if(recipient().message) {
        <label class="input-label fw-bold">Message</label>
        <div class="recipient__message__content italic">{{recipient().message}}</div>
        }
    </div>
    <div class="recipient__actions">
        @if(!loading()) {
        @if(recipient().recipient.kind === 'user') {
        <span id="main" [pTooltip]="!recipient().mainRecipient ? 'Définir comme principal' : 'Principal'"
            [tooltipPosition]="'left'" (click)="setRecipientAsMain()">
            <i class="bi" [ngClass]="recipient().mainRecipient ? 'bi-star-fill' : 'bi-star'"></i>
        </span>
        }
        <span id="delete" [pTooltip]="'Supprimer le destinataire'" [tooltipPosition]="'left'"
            (click)="deleteRecipient()">
            <i class="bi bi-trash-fill"></i>
        </span>
        }@else {
        <span><i-loader></i-loader></span>
        }
    </div>
</div>